/* ABBOUSAYF · thème sense-v4 · JS global */
const EURJS = c => {
  const v = c / 100;
  return (Math.round(v * 100) % 100 === 0 ? String(Math.round(v)) : v.toFixed(2).replace(".", ",")) + "€";
};

function toggleMenu(open){ const el=document.getElementById("mnav"); if(el) el.classList.toggle("open", open); }
function toggleCart(open){
  const el=document.getElementById("cart-drawer"); if(!el) return;
  el.classList.toggle("open", open);
  if(open) refreshCart();
}
function showToast(msg){
  const t=document.getElementById("toast"); if(!t) return;
  t.textContent=msg; t.classList.add("show");
  clearTimeout(t._h); t._h=setTimeout(()=>t.classList.remove("show"),2400);
}

/* ---------- panier AJAX ---------- */
async function refreshCart(){
  const wrap=document.getElementById("cart-items"); if(!wrap) return;
  const cart=await fetch("/cart.js").then(r=>r.json());
  const count=document.getElementById("cart-count");
  if(count) count.textContent=cart.item_count;
  if(!cart.items.length){
    wrap.innerHTML='<div class="cart-empty">Votre panier est vide.<br><br><a class="btn" href="/collections/all">Découvrir nos parfums</a></div>';
  }else{
    wrap.innerHTML=cart.items.map((i,idx)=>`
      <div class="cart-item">
        <img src="${i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/, "_200x$1$2") : ""}" alt="">
        <div>
          <div class="ci-name">${i.product_title}</div>
          <div class="ci-var">${i.variant_title || ""}</div>
          <div class="ci-price">${EURJS(i.final_line_price)}</div>
          <div class="ci-qty">
            <button onclick="changeQty(${idx+1},${i.quantity-1})">−</button><span>${i.quantity}</span><button onclick="changeQty(${idx+1},${i.quantity+1})">+</button>
            <button class="ci-remove" onclick="changeQty(${idx+1},0)">Retirer</button>
          </div>
        </div>
      </div>`).join("");
  }
  const total=document.getElementById("cart-total");
  if(total) total.textContent=EURJS(cart.total_price);
  const ship=document.getElementById("shipbar");
  const drawer=document.getElementById("cart-drawer");
  if(ship && drawer){
    const seuil=parseInt(drawer.dataset.freeShipping||"8000",10);
    if(cart.total_price>=seuil) ship.innerHTML='🎉 <b>Livraison offerte !</b><div class="bar"><div class="fill" style="width:100%"></div></div>';
    else ship.innerHTML=`Plus que <b>${EURJS(seuil-cart.total_price)}</b> pour la livraison offerte 🚚<div class="bar"><div class="fill" style="width:${Math.min(100,cart.total_price/seuil*100)}%"></div></div>`;
  }
}
async function changeQty(line,qty){
  await fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({line,quantity:qty})});
  refreshCart();
}
async function addVariant(id,quantity,properties){
  const body={id:Number(id),quantity:quantity||1};
  if(properties) body.properties=properties;
  const r=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(body)});
  if(r.ok){ showToast("Ajouté au panier ✓"); toggleCart(true); }
  else{ const e=await r.json().catch(()=>({})); showToast(e.description||"Impossible d'ajouter cet article"); }
}

document.addEventListener("DOMContentLoaded",()=>{
  refreshCart();

  /* ajout rapide depuis les cartes */
  document.addEventListener("click",e=>{
    const q=e.target.closest("[data-quick-add]");
    if(q){ e.preventDefault(); e.stopPropagation(); addVariant(q.dataset.quickAdd,1); }
  });

  /* marquee : dupliquer la piste */
  document.querySelectorAll("[data-marquee]").forEach(tr=>{ tr.innerHTML=tr.innerHTML.repeat(4); });

  /* onglets génériques (best-sellers, familles) */
  document.querySelectorAll("[data-tabs]").forEach(tabbar=>{
    const root=tabbar.parentElement;
    tabbar.querySelectorAll("[data-tab]").forEach(btn=>btn.addEventListener("click",()=>{
      tabbar.querySelectorAll("[data-tab]").forEach(b=>b.classList.remove("active"));
      btn.classList.add("active");
      root.querySelectorAll("[data-panel]").forEach(p=>{
        p.style.display = p.dataset.panel===btn.dataset.tab ? "" : "none";
      });
    }));
  });

  /* vidéo TF1 : lecture au clic avec son */
  const wrap=document.getElementById("tf1-wrap");
  if(wrap){
    const v=wrap.querySelector("video"), pb=document.getElementById("tf1-play");
    if(v&&pb){
      v.removeAttribute("controls");
      pb.addEventListener("click",()=>{v.setAttribute("controls","");v.muted=false;v.play();pb.style.display="none";});
    }
  }

  /* avis : voir plus */
  const more=document.querySelector("[data-reviews-more]");
  if(more) more.addEventListener("click",()=>{
    document.querySelectorAll("[data-review-hidden]").forEach(r=>r.style.display="");
    more.style.display="none";
  });

  /* ---------- page produit ---------- */
  const form=document.getElementById("product-form");
  if(form){
    let qty=1;
    const qv=document.getElementById("q-val"), qi=document.getElementById("quantity-input");
    const setQty=n=>{qty=Math.max(1,n);if(qv)qv.textContent=qty;if(qi)qi.value=qty;};
    const qm=document.getElementById("q-minus"), qp=document.getElementById("q-plus");
    if(qm)qm.addEventListener("click",()=>setQty(qty-1));
    if(qp)qp.addEventListener("click",()=>setQty(qty+1));

    /* variantes */
    document.querySelectorAll("#sizes .size").forEach(b=>b.addEventListener("click",()=>{
      document.querySelectorAll("#sizes .size").forEach(x=>x.classList.remove("active"));
      b.classList.add("active");
      document.getElementById("variant-id").value=b.dataset.variant;
      const price=parseInt(b.dataset.price,10);
      const now=document.getElementById("price-now");
      if(now) now.textContent=EURJS(price);
      const save=document.getElementById("price-save");
      if(save){
        const niche=parseInt(save.dataset.niche,10);
        const eco=Math.max(0,niche-price);
        save.textContent="−"+Math.round(eco*100/niche)+"% · Vous économisez "+EURJS(eco);
      }
      const saPrice=document.getElementById("sa-price");
      if(saPrice) saPrice.firstChild.textContent=EURJS(price)+" ";
      const saName=document.getElementById("sa-name");
      if(saName) saName.textContent=document.getElementById("sticky-atc").dataset.productTitle+" · "+b.textContent.trim().split("\n")[0];
    }));

    /* soumission AJAX */
    form.addEventListener("submit",e=>{
      e.preventDefault();
      const fd=new FormData(form);
      fetch("/cart/add.js",{method:"POST",body:fd}).then(r=>{
        if(r.ok){showToast("Ajouté au panier ✓");toggleCart(true);}
        else r.json().then(j=>showToast(j.description||"Impossible d'ajouter cet article")).catch(()=>showToast("Impossible d'ajouter cet article"));
      });
    });

    /* barre sticky mobile */
    const sticky=document.getElementById("sticky-atc");
    const stickyBtn=document.getElementById("sticky-add");
    if(stickyBtn) stickyBtn.addEventListener("click",()=>form.requestSubmit());
    if(sticky) window.addEventListener("scroll",()=>{
      sticky.classList.toggle("show",window.scrollY>520&&window.innerWidth<768);
    });

    /* module cadeau */
    window.toggleGift=()=>{
      const mod=document.getElementById("giftmod"); if(!mod) return;
      mod.classList.toggle("open");
      document.getElementById("gift-switch").classList.toggle("on");
      const active=mod.classList.contains("open");
      ["gift-flag","gift-sign","gift-name","gift-canal","gift-contact"].forEach(id=>{
        const el=document.getElementById(id); if(el) el.disabled=!active;
      });
      const flag=document.getElementById("gift-flag"); if(flag) flag.value=active?"Oui":"";
      updateGiftPreview();
    };
    const updateGiftPreview=()=>{
      const prev=document.getElementById("gift-preview"); if(!prev) return;
      const sign=document.getElementById("gift-sign").value;
      const canal=document.getElementById("gift-canal").value;
      const name=(document.getElementById("gift-name").value||"").trim();
      const nameWrap=document.getElementById("gift-name-wrap");
      if(nameWrap) nameWrap.style.display=sign==="À mon nom"?"block":"none";
      const from=sign==="À mon nom"?(name?"de la part de <b>"+name.replace(/</g,"")+"</b>":"de la part de … <i>(entrez votre nom ci-dessus)</i>"):"d'un admirateur secret 🤫";
      prev.innerHTML="<b>Aperçu du message reçu par "+canal+" :</b><br>« Un cadeau vous attend : le parfum <b>"+prev.dataset.productTitle+"</b> de la maison Abbousayf, "+from+". Il arrive très bientôt chez vous ✨ »";
      const contact=document.getElementById("gift-contact");
      if(contact) contact.placeholder=canal==="WhatsApp"?"Numéro WhatsApp du destinataire":"E-mail du destinataire";
    };
    const segBind=(segId,hiddenId)=>{
      document.querySelectorAll("#"+segId+" button").forEach(b=>b.addEventListener("click",()=>{
        document.querySelectorAll("#"+segId+" button").forEach(x=>x.classList.remove("active"));
        b.classList.add("active");
        document.getElementById(hiddenId).value=b.dataset.v;
        updateGiftPreview();
      }));
    };
    segBind("seg-sign","gift-sign");
    segBind("seg-canal","gift-canal");
    const gn=document.getElementById("gift-name");
    if(gn) gn.addEventListener("input",updateGiftPreview);
    updateGiftPreview();
  }

  /* ---------- composeur de pack ---------- */
  const pb=document.getElementById("pack-builder");
  if(pb){
    let variant=0, picks=[];
    const needs=[parseInt(pb.dataset.need1,10)||4, parseInt(pb.dataset.need2,10)||7];
    const variants=[pb.dataset.variant1, pb.dataset.variant2];
    const prices=[parseInt(pb.dataset.price1,10)||0, parseInt(pb.dataset.price2,10)||0];
    const picker=document.getElementById("picker");
    const need=()=>needs[variant];

    const refresh=()=>{
      const missing=need()-picks.length;
      const sel=document.getElementById("sel-count");
      if(sel) sel.textContent=picks.length+" / "+need()+" sélectionnés";
      document.getElementById("pk-fill").style.width=Math.min(100,picks.length/need()*100)+"%";
      const btn=document.getElementById("pk-btn");
      const priceTxt=prices[variant]>0?" · "+EURJS(prices[variant]):"";
      if(!variants[variant]){
        document.getElementById("pk-msg").innerHTML="⚠️ Sélectionnez le produit « Pack à composer » dans les réglages de la section";
        btn.disabled=true;
        btn.textContent="CONFIGURATION REQUISE";
      }else if(missing>0){
        document.getElementById("pk-msg").innerHTML="Encore <b>"+missing+" parfum"+(missing>1?"s":"")+"</b> à choisir pour valider votre pack";
        btn.disabled=true;
        btn.textContent="CHOISISSEZ "+missing+" PARFUM"+(missing>1?"S":"");
      }else{
        document.getElementById("pk-msg").innerHTML="✅ Votre pack est complet"+priceTxt;
        btn.disabled=false;
        btn.textContent="AJOUTER MON PACK AU PANIER"+priceTxt;
      }
      picker.querySelectorAll(".pick").forEach(el=>{
        const n=picks.filter(h=>h===el.dataset.h).length;
        el.classList.toggle("selected",n>0);
        el.querySelector(".qtybadge").textContent="×"+n;
        const b=el.querySelector(".padd");
        b.textContent=n>0?"Ajouté ×"+n+" · encore +":"Ajouter +";
      });
    };

    picker.addEventListener("click",e=>{
      const add=e.target.closest("[data-add]");
      if(!add) return;
      const h=add.dataset.add;
      if(picks.length>=need()){
        const idx=picks.indexOf(h);
        if(idx>-1){picks.splice(idx,1);refresh();return;}
        showToast("Pack complet : retirez un parfum ou passez au pack supérieur");
        return;
      }
      picks.push(h);refresh();
    });

    document.querySelectorAll(".pk-variant").forEach(b=>b.addEventListener("click",()=>{
      variant=+b.dataset.v;
      document.querySelectorAll(".pk-variant").forEach(x=>x.classList.toggle("active",+x.dataset.v===variant));
      if(picks.length>need()) picks=picks.slice(0,need());
      refresh();
    }));

    document.getElementById("pk-btn").addEventListener("click",()=>{
      if(picks.length<need()||!variants[variant]) return;
      const properties={};
      picks.forEach((name,i)=>{properties["Parfum "+(i+1)]=name;});
      addVariant(variants[variant],1,properties).then(()=>{picks=[];refresh();});
    });

    refresh();
  }
});

/* ---------- animations d'apparition, subtiles et une seule fois ---------- */
document.addEventListener("DOMContentLoaded",()=>{
  if(window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  if(!("IntersectionObserver" in window)) return;
  const io=new IntersectionObserver(entries=>{
    entries.forEach(e=>{
      if(e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target); }
    });
  },{rootMargin:"0px 0px -6% 0px",threshold:0.06});
  const sel=".pcard,.packcard,.review,.note,.prop,.gchip,.info-card,.pick,.section-heading,.section-kicker,.tf1-quote,.tf1-badge-row,.stats,.rating-head,.pk-why,.pk-variant,.compare,.compare-note,.faq details,.gtext,.gimg,.pricecard,.giftmod,.notes";
  document.querySelectorAll(sel).forEach(el=>{
    const idx=[...el.parentElement.children].indexOf(el);
    el.classList.add("reveal");
    el.style.transitionDelay=Math.min(idx,5)*60+"ms";
    io.observe(el);
  });
});
